import { render, staticRenderFns } from "./compliance-details-card.vue?vue&type=template&id=6681b2f4"
import script from "./compliance-details-card.vue?vue&type=script&lang=js"
export * from "./compliance-details-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports